import { render, staticRenderFns } from "./SelectorTemplatePromo.vue?vue&type=template&id=3c348b97&scoped=true"
import script from "./SelectorTemplatePromo.vue?vue&type=script&lang=js"
export * from "./SelectorTemplatePromo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./SelectorTemplatePromo.vue?vue&type=style&index=2&id=3c348b97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c348b97",
  null
  
)

export default component.exports